import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import {
  buildWorkOrderStockTransferUpdatePayload,
} from '#/api/momMgmt/workOrder/transfer/serializeTransferWrite';

/**
 * PATCH `/mom/work-order/stock-transfer/{id}`（僅 DRAFT）。
 *
 * @param {string} id
 * @param {object} values
 */
export async function updateWorkOrderStockTransfer(id, values) {
  const { data: raw } = await request.patch(
    `/mom/work-order/stock-transfer/${id}`,
    keysToSnake(buildWorkOrderStockTransferUpdatePayload(values)),
  );
  return parseVer4DetailResponse(raw);
}
